window.channeldata = [];
window.page = 1;
window.size = 3;
window.gethotest = function (total) {
    size = total;
    getlist();
};
window.getlist = function () {
    showWait();
    $.ajax({
        type: 'get',
        async: true,
        url: ROOT + '/activities/getAll?page=' + page + '&size=' + size,
        data: {},
        contentType: 'application/json',
        dataType: 'json',
        success: function (result) {
            if (result) {
                if (result.error == undefined) {
                    channeldata = result.data;
                    createliveinfo(10);
                    page++;
                } else {
                    // alert(result.message);
                }
            }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            // alert(XMLHttpRequest.responseText);
        },
        complete: function (XMLHttpRequest, textStatus) {
            hideWait();

            if (channeldata.length == 0) {
                $('.loadmore').hide();
                $('.loadinfo').show();
            } else {
                $('.loadmore').show();
                $('.loadinfo').hide();

            }
        }
    });
};

window.createliveinfo = function (count) {
    for (var i = 0; i < channeldata.length; i++) {
        createContent(channeldata[i].id, channeldata[i].name, count);
    }
};

function createContent(id, name, count) {
    $.ajax({
        type: 'get',
        async: true,
        url: ROOT + '/activities/get/' + id + '/contents?sort=1&page=1&size=10',
        data: {},
        contentType: 'application/json',
        dataType: 'json',
        success: function (result) {
            if (result.data.length == 0) {
                return;
            }

            var str = '';
            for (var n = 0; n < result.data.length; n++) {
                if (n == count) {
                    break;
                }
                var info = result.data[n];
                var targetHtml = '<a target="_blank" href="' + ROOT + '/content/' + info.id + '">';

                var html =
                    '<div class="liveinfo">' +
                    targetHtml +
                    '<div class="liveinfo-img">' +
                    '<img src="' + info.cover_url + '?w=370&h=162&s=3">' +
                    '<div class="liveinfo-type"></div>' +
                    '<div class="liveinfo-hover"></div>' +
                    '</div>' +
                    '<div class="liveinfo-title">' +
                    '<div class="liveinfo-title-name">' + info.title + '</div>' +
                    '</div>' +
                    '<div class="liveinfo-user">' +
                    '<div class="liveinfo-user-name">' + (info.author_nickname || '') + '</div>' +
                    '<div class="liveinfo-user-visitcount">' + info.like_count + '</div>' +
                    '</div>' +
                    '</a>' +
                    '</div>';

                str += html;
            }

            var html = '<div class="showtabs">' +
                '            <div class="showtab">' + name + '</div>' +
                '            <a class="showtab-more" target="_blank" href="' + ROOT + '/activities/' + id + '">更多</a>' +
                '        </div>' +
                '        <div class="curentlives">' +
                '            <div class="livelist">' +
                str +
                '            </div>' +
                '        </div>';

            $('.list').append(html);
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
        },
        complete: function (XMLHttpRequest, textStatus) {
        }
    });
}

$('.loadmore').click(function () {
    gethotest(size);
    // scrollbuttom();
});

window.scrollbuttom = function () {
    $('html').animate({ scrollTop: $('html').height() }, 1000);
};

window.num = 1; // 计数器初始化为1
window.maxnum = 1000; // 设置一共要加载几次
$(window).scroll(function () {
    // 下面这句主要是获取网页的总高度，主要是考虑兼容性所以把Ie支持的documentElement也写了，这个方法至少支持IE8
    var htmlHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
    // clientHeight是网页在浏览器中的可视高度，
    var clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
    // scrollTop是浏览器滚动条的top位置，
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    // 通过判断滚动条的top位置与可视网页之和与整个网页的高度是否相等来决定是否加载内容；
    if (scrollTop + clientHeight >= htmlHeight) {
        gethotest(size);
    }
    // if ($('.loadmore').length > 0 && $('.curentlives').css('display') == 'block') {
    //     checkload();
    // }
});

window.checkload = function () {


    var srollPos = $(window).scrollTop(); // 滚动条距离顶部的高度

    var windowHeight = $(window).height(); // 窗口的高度

    var dbHiht = $('body').height(); // 整个页面文件的高度

    setTimeout(function () {
        if ((windowHeight + srollPos) >= (dbHiht) && num != maxnum) {
            gethotest(size);
            num++; // 计数器+1
        }

    }, 100);
};